import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import WhatsAppWidget from '../common/WhatsAppWidget';

const PublicLayout = () => {
  return (
    <div className="min-h-screen flex flex-col bg-surface-main dark:bg-dark-bg text-gray-900 dark:text-gray-100 overflow-x-hidden selection:bg-primary-500 selection:text-white transition-colors duration-200 pb-[env(safe-area-inset-bottom)]">
      <Header />

      <main className="flex-1 w-full relative">
        <Outlet />
      </main>

      <Footer />
      <WhatsAppWidget />
    </div>
  );
};

export default PublicLayout;


